<script lang="ts">
  import { slide } from 'svelte/transition';
  import Button from './Button.svelte';
  import Chevron from '$icons/Chevron.svelte';
  import { linkify } from '$utils';
  import { cn } from '$lib/utils/misc';

  export let text: string;
  export let shadowIntensity: 'light' | 'medium' | 'dark' = 'dark';
  export let maxHeight = 120;

  let expanded = false;
  let isOverflown: boolean;
  let element: HTMLElement;
  const checkOverflow = (paragraphElement: HTMLParagraphElement) => {
    isOverflown = paragraphElement.scrollHeight > paragraphElement.clientHeight;
  };
</script>

<div bind:this={element} class={cn('relative flex flex-col items-start gap-2', $$props.class)}>
  <p
    transition:slide
    use:checkOverflow
    class="text-gray-dark-12 overflow-hidden whitespace-pre-wrap break-words text-sm leading-5"
    style={expanded ? 'max-height: none;' : `max-height: ${maxHeight}px;`}
  >
    {@html linkify(text ?? '')}
  </p>
  {#if isOverflown}
    <div
      class:hidden={expanded}
      class=" {shadowIntensity == 'dark'
        ? 'text-background'
        : 'from-gray-dark-1  bg-gradient-to-t to-transparent'} absolute bottom-0 h-[60px] w-full"
    />
  {/if}
</div>
{#if isOverflown}
  <Button
    quinary
    class="z-10 {expanded ? 'mt-3' : ''}"
    on:click={() => {
      expanded = !expanded;
      if (!expanded) element.scrollTop = 0;
    }}
  >
    <Chevron class=" transform duration-500 {expanded ? 'rotate-180' : 'rotate-0'}" />
    <span>
      {#if expanded}
        See less
      {:else}
        See more
      {/if}
    </span>
  </Button>
{/if}
